import { render, staticRenderFns } from "./CreateProspect.vue?vue&type=template&id=5e3a2011&scoped=true&"
import script from "./CreateProspect.vue?vue&type=script&lang=js&"
export * from "./CreateProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a2011",
  null
  
)

export default component.exports